<style scoped lang="scss">
    @import '~@/abstracts/_variables.scss';

    div#order-service-page {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: white;
        z-index: 9999;
        overflow: auto;

        img#back {
            float: right;
            margin-top: 20px;
            margin-right: 20px;
        }

        div.close-block {
            top: 0.5rem;
            right: 0.5rem;
            position: absolute;

            a.close-block-button {
                justify-content: center;
                align-items: center;
                display: inline-flex;
                border-radius: 0.375rem;
                outline: 2px solid transparent;
                outline-offset: 2px;
                color: rgb(156, 163, 175);
                padding: 0.5rem;

                svg {
                    width: 2.5rem;
                    height: 2.5rem;
                }

                &:hover {
                    background-color: rgb(243, 244, 246);
                    color: rgb(107, 114, 128);
                }
            }
        }

        .centered {
            margin: auto;
        }

        span.development-label {
            position: absolute;
            font-family: 'Raleway', sans-serif;
            font-size: 16px;
            color: #fff;
            background-color: #dc3545;
            padding: 0.25rem 0.875rem;
            border-radius: 5px;
            font-weight: bold;
            float: left;
            margin-top: 22px;
            margin-left: 10px;
        }

        h2.page-title {
            display: block;
            color: $secondary-color;
            font-size: 36px;
            font-weight: bold;
            font-family: 'Raleway', sans-serif;
            margin-top: 60px;
            text-align: center;
        }

        h5.section-title {
            font-family: 'Raleway', sans-serif;
            font-weight: bold;
            text-align: center;
            margin-bottom: 20px;
            margin-top: 20px;
        }

        span.section-description {
            display: block;
            font-family: 'Raleway', sans-serif;
            text-align: center;
            margin-bottom: 20px;
            margin-top: 20px;
        }

        span.service-title {
            display: block;
            color: #342C0C;
            font-size: 26px;
            font-weight: bold;
            font-family: 'Raleway', sans-serif;
            margin-top: 20px;
            text-align: center;
        }

        label.form-label {
            font-family: 'Raleway', sans-serif;
            font-weight: bold;
            text-align: left;
            color: black;
            margin-top: 10px;
            margin-bottom: 0;

            &.required:after {
                color: red;
                content: " *";
            }
        }

        input[type="text"].form-input {
            font-family: 'Raleway', sans-serif;
            border: 1px solid #BABABA;
            border-radius: 3px;

            &.invalid{
                border: 1px solid #D0021B;
            }
        }

        input[type="date"].form-input {
            font-family: 'Raleway', sans-serif;
            border: 1px solid #BABABA;
            border-radius: 3px;

            &.invalid{
                border: 1px solid #D0021B;
            }
        }

        input[type=checkbox] {
            width: 1.5rem;
            height: 1.5rem;
            margin-bottom: 0rem;
            color: $secondary-color;
            vertical-align: middle;
            -webkit-appearance: none;
            background: none;
            border: 0;
            outline: 0;
            flex-grow: 0;
            border-radius: 5px;
            background-color: #ffffff;
            transition: background 300ms;
            cursor: pointer;

            &::before {
                content: "";
                color: transparent;
                display: block;
                width: inherit;
                height: inherit;
                border-radius: inherit;
                border: 0;
                background-color: transparent;
                background-size: contain;
                box-shadow: inset 0 0 0 1px #CCD3D8;
            }

            &::-ms-check {
                content: "";
                color: transparent;
                display: block;
                width: inherit;
                height: inherit;
                border-radius: inherit;
                border: 0;
                background-color: transparent;
                background-size: contain;
                box-shadow: inset 0 0 0 1px #CCD3D8;
            }

            &:checked {
                background-color: $secondary-color;

                &::before {
                    box-shadow: none;
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E %3Cpath d='M15.88 8.29L10 14.17l-1.88-1.88a.996.996 0 1 0-1.41 1.41l2.59 2.59c.39.39 1.02.39 1.41 0L17.3 9.7a.996.996 0 0 0 0-1.41c-.39-.39-1.03-.39-1.42 0z' fill='%23fff'/%3E %3C/svg%3E");
                }

                &::-ms-check {
                    box-shadow: none;
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E %3Cpath d='M15.88 8.29L10 14.17l-1.88-1.88a.996.996 0 1 0-1.41 1.41l2.59 2.59c.39.39 1.02.39 1.41 0L17.3 9.7a.996.996 0 0 0 0-1.41c-.39-.39-1.03-.39-1.42 0z' fill='%23fff'/%3E %3C/svg%3E");
                }
            }

            &:disabled {
                background-color: #CCD3D8;
                opacity: 0.84;
                cursor: not-allowed;
            }
        }

        textarea.text-input {
            font-family: 'Raleway', sans-serif;
            border: 1px solid #BABABA;
            border-radius: 3px;
            font-size: 14px;

            &.invalid {
                border: 1px solid #D0021B;
            }
        }

        span.selected-slot-text {
            display: block;
            font-family: 'Raleway', sans-serif;
            text-align: center;
            font-weight: bold;
        }

        div.radio-btn-group {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;

            .radio {
                //margin: 0 .25rem;

                label {
                    font-family: 'Raleway', sans-serif;
                    font-weight: bold;
                    text-align: center;
                    background: #fff;
                    border: 1px solid #ddd;
                    padding: 3px 15px;
                    border-radius: 5px;
                    cursor: pointer;
                    color: #444;
                    transition: box-shadow 400ms ease;

                    &:hover {
                        box-shadow: 0 2px 5px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12);
                    }
                }

                input[type="radio"] {
                    display: none;
                }

                input[type="radio"]:checked+label {
                    background: $secondary-color;
                    border-color: $secondary-color;
                    color: #fff !important;
                }
            }
        }

        ul.service-operations-list {
            list-style-type: none;
            margin-left: 1.25rem;
            margin-right: 1.25rem;

            li {
                display: block;
                border: 1px solid #f9f9f9;
                background-color: #f9f9f9;
                padding: 10px;
                margin: 0px 0px 10px;
                border-radius: 5px;

                label {
                    display: inline-block;
                    font-weight: bold;

                    span.checkbox-label {
                        vertical-align: middle;
                    }
                }

                span.info-icon {
                    margin-left: 0.5rem;
                }

                img.info-icon {
                    width: 16px;
                }
            }

            div.container {
                padding-left: 15px;
                margin-top: 10px;
            }

            span:focus {
                outline: none;
            }
        }

        ul.extended-services-operations-list {
            list-style-type: none;
            margin-left: 1.25rem;
            margin-right: 1.25rem;

            li {
                border: 1px solid #f9f9f9;
                padding: 10px;
                margin: 0px 0px 10px;
                display: block;
                background-color: #f9f9f9;
                border-radius: 5px;
                text-align: center;

                label {
                    font-weight: bold;

                    span.checkbox-label {
                        vertical-align: middle;
                    }
                }
            }
        }

        div.custom-control {
            display: inline-block;
            padding-left: 20px;
            padding-right: 20px;
        }

        fieldset.checkbox-option-wrapper {
            display: inline-block;
            text-align: center;
            border: none !important;
            width: 100%;

            div.checkbox-option-container {
                padding-left: 0;
                padding-right: 0;
            }

            label.checkbox-option-label {
                /*display: inline-block;*/
                display: -ms-inline-flexbox;
                display: inline-flex;
                -ms-flex-align: center;
                align-items: center;
                -ms-flex-pack: center;
                justify-content: center;
                width: auto;
                height: 35px !important;
                background: #fff;
                height: 100%;
                width: 100%;
                text-align: center;
                border-radius: 2em;
                cursor: pointer;
                margin: 5px 5px 5px 5px;
                padding: 5px 10px 5px 10px;
                border: 1px solid lightgrey;
                transition: all 0.3s ease;

                &::after {
                    display: none;
                }

                div.checkbox-option-dot {
                    display: inline-block;
                    height: 15px;
                    width: 15px;
                    background: #d9d9d9;
                    margin-right: 5px;
                    border-radius: 50%;
                    position: relative;

                    &::before {
                        position: absolute;
                        content: "";
                        top: 3px;
                        left: 3px;
                        width: 9px;
                        height: 9px;
                        background: $secondary-color;
                        border-radius: 50%;
                        opacity: 0;
                        transform: scale(1.5);
                        transition: all 0.3s ease;
                    }
                }

                span {
                    color: #808080;
                }
            }

            label.checkbox-option-label-small {
                width: 95px;
            }

            input[type="radio"] {
                display: none;
            }
        }

        .checkbox-option-label:checked:checked ~ .checkbox-option-label {
            background: linear-gradient(90deg, $secondary-color, $secondary-color);
        }

        .checkbox-option-label:checked:checked ~ .checkbox-option-label span {
            color: #fff;
        }

        .checkbox-option-label:checked:checked ~ .checkbox-option-label .checkbox-option-dot {
            background: #fff;
        }

        .checkbox-option-label:checked:checked ~ .checkbox-option-label .checkbox-option-dot::before {
            opacity: 1;
            transform: scale(1);
        }

        .checkbox-option-label:disabled ~ .checkbox-option-label {
            background: #d9d9d9;
        }

        div.validation {
            color: #D0021B;
            font-family: 'Raleway', sans-serif;
            font-size: 14px;
            margin-top: -15px;
            margin-bottom: 15px;
            text-align: left;
        }

        span.service-info-text {
            font-family: 'Raleway', sans-serif;
            font-size: 14px;
            color: #666666;
        }

        span.bottom-security-text {
            display: block;
            font-family: 'Raleway', sans-serif;
            color: #666666;
            font-style: italic;
            padding: 20px;

            a {
                color: $secondary-color;
            }

            .mandatory {
                color: red;
                font-size: 22px;
            }
        }

        a.order-button {
            display: block;
            text-align: center;
            height: 50px;
            color: white;
            border-radius: 5px;
            font-size: 16px;
            font-weight: 700 !important;
            font-family: 'Raleway', sans-serif;
            background-color: $secondary-color;
            -webkit-appearance: none;
            transition: color .2s cubic-bezier(0.55, 0.085, 0.68, 0.53),box-shadow .2s cubic-bezier(0.55, 0.085, 0.68, 0.53),background-color .2s cubic-bezier(0.55, 0.085, 0.68, 0.53);
            border: none;
            line-height: 50px;
            margin-bottom: 60px;
            margin-top: 20px;

            &:hover {
                background-color: #810050;
            }
        }
    }

    /* Small only */
    @media screen and (max-width: 39.9375em) {
        div#order-service-page {
            span.development-label {
                display: none;
            }

            h2.page-title {
                font-size: 25px;
            }
        }
    }
</style>

<template>
    <transition name="scale-in-center">
        <div id="order-service-page">
            <span class="development-label" v-if="app_env == 'local' || app_env == 'development'">
                Testovací prostředí
            </span>

            <div class="close-block">
                <a v-on:click="closeModal()" class="close-block-button">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                </a>
            </div>

            <div class="grid-container">
                <div class="grid-x grid-padding-x">
                    <div class="large-8 medium-9 small-12 cell centered">
                        <h2 class="page-title" v-if="serviceLoadStatus == 2 && (this.service.maintenance_slot == true && !this.makeId)">{{ $t('order.titleBinding') }}</h2>
                        <h2 class="page-title" v-if="serviceLoadStatus == 2 && ((this.service.maintenance_slot == false) || (this.service.maintenance_slot == true && this.makeId))">{{ $t('order.title') }}</h2>
                        <span class="service-title" v-if="serviceLoadStatus == 2">{{ serviceName }}</span>
                    </div>
                </div>

                <loader v-show="serviceLoadStatus == 0 || serviceLoadStatus == 1" :width="100" :height="100"></loader>

                <div class="grid-x grid-padding-x" v-if="serviceLoadStatus == 2">
                    <div class="large-8 medium-9 small-12 cell centered">
                        <div class="grid-x grid-padding-x">
                            <div class="large-6 medium-6 small-12 cell">
                                <label class="form-label">{{ $t('order.licensePlate') }}</label>
                                <input type="text" class="form-input" v-model="license" readonly />
                            </div>
                            <div class="large-6 medium-6 small-12 cell">
                                <label class="form-label required">{{ $t('order.mileage') }}</label>
                                <input type="text" v-on:keypress="validNumber" @paste.prevent v-model="mileage" ref="mileage" maxlength="7" v-bind:class="{ 'invalid' : !validations.mileage.is_valid }" class="form-input" />
                                <div class="validation" v-show="!validations.mileage.is_valid">{{ validations.mileage.text }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid-x grid-padding-x" v-if="serviceLoadStatus == 2">
                    <div class="large-8 medium-9 small-12 cell centered">
                        <h5 class="section-title">{{ $t('order.contactSectionLabel') }}</h5>

                        <div class="grid-x grid-padding-x">
                            <div class="large-6 medium-6 small-12 cell">
                                <label class="form-label required">{{ $t('order.firstName') }}</label>
                                <input type="text" v-model="firstName" ref="firstName" v-bind:class="{ 'invalid' : !validations.firstName.is_valid }" class="form-input" />
                                <div class="validation" v-show="!validations.firstName.is_valid">{{ validations.firstName.text }}</div>
                            </div>
                            <div class="large-6 medium-6 small-12 cell">
                                <label class="form-label required">{{ $t('order.lastName') }}</label>
                                <input type="text" v-model="lastName" ref="lastName" v-bind:class="{ 'invalid' : !validations.lastName.is_valid }" class="form-input" />
                                <div class="validation" v-show="!validations.lastName.is_valid">{{ validations.lastName.text }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid-x grid-padding-x" v-if="serviceLoadStatus == 2">
                    <div class="large-8 medium-9 small-12 cell centered">
                        <div class="grid-x grid-padding-x">
                            <div class="large-6 medium-6 small-12 cell">
                                <label class="form-label required">{{ $t('order.email') }}</label>
                                <input type="text" v-model="emailAddress" ref="emailAddress" v-bind:class="{ 'invalid' : !validations.emailAddress.is_valid }" class="form-input" />
                                <div class="validation" v-show="!validations.emailAddress.is_valid">{{ validations.emailAddress.text }}</div>
                            </div>
                            <div class="large-6 medium-6 small-12 cell">
                                <label class="form-label required">{{ $t('order.phone') }}</label>
                                <VuePhoneNumberInput v-model="phoneNumber" @update="onUpdatePhoneNumber" maxlength="11" color="#c8017d" default-country-code="CZ" required :only-countries="phoneNumberOnlyCountries" :translations="phoneNumberTranslations" />
                                <div class="validation" v-show="!validations.phoneNumber.is_valid">{{ validations.phoneNumber.text }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid-x grid-padding-x" v-if="serviceLoadStatus == 2">
                    <div class="large-8 medium-9 small-12 cell centered">
                        <h5 class="section-title" v-if="this.maintenanceIncluded == true">{{ $t('order.servicingActionsSectionLabel') }}</h5>
                        <h5 class="section-title" v-if="this.maintenanceIncluded == false">{{ $t('order.servicingActionSectionLabel') }}</h5>

                        <span class="section-description" v-if="this.maintenanceIncluded == true">{{ $t('order.servicingActionSectionInfo') }}</span>
                        <span class="section-description" v-html="$t('order.servicingActionSectionNote')"></span>

                        <div class="validation" style="text-align: center;" v-show="!validations.serviceOperations.is_valid">{{ validations.serviceOperations.text }}</div>

                        <div class="grid-x grid-padding-x">
                            <div class="large-6 medium-6 small-12 cell">
                                <ul class="service-operations-list">
                                    <li v-if="this.maintenanceIncluded == true">
                                        <label for="service-inspection">
                                            <input type="checkbox" id="service-inspection" value="service-inspection" v-model="serviceOperations">
                                            <span class="checkbox-label">{{ $t('order.servicingActionServiceInspectionLabel') }}</span>
                                        </label>

                                        <span class="info-icon" :content="$t('order.servicingActionServiceInspectionTooltip')" v-tippy="{ placement : 'right',  arrow: true }">
                                            <img src="/img/info-icon.svg" class="info-icon">
                                        </span>
                                    </li>

                                    <li v-if="this.maintenanceIncluded == true">
                                        <label for="repair">
                                            <input type="checkbox" id="repair" value="repair" v-model="serviceOperations">
                                            <span class="checkbox-label">{{ $t('order.servicingActionRepairLabel') }}</span>
                                        </label>

                                        <span class="info-icon" :content="$t('order.servicingActionRepairTooltip')" v-tippy="{ placement : 'right',  arrow: true }">
                                            <img src="/img/info-icon.svg" class="info-icon">
                                        </span>

                                        <transition name="fade">
                                            <div class="container" id="repair-text-container" v-if="serviceOperations.includes('repair')">
                                                <textarea rows="2" class="text-input" v-model="serviceOperationsRepairText" v-bind:class="{ 'invalid' : !validations.serviceOperationsRepairText.is_valid }" :placeholder="$t('order.servicingActionInputTextPlaceholder')"></textarea>
                                                <div class="validation" v-show="!validations.serviceOperationsRepairText.is_valid">{{ validations.serviceOperationsRepairText.text }}</div>
                                            </div>
                                        </transition>
                                    </li>

                                    <li v-if="this.maintenanceIncluded == true">
                                        <label for="technical-inspection">
                                            <input type="checkbox" id="technical-inspection" value="technical-inspection" v-model="serviceOperations">
                                            <span class="checkbox-label">{{ $t('order.servicingActionTechnicalInspectionLabel') }}</span>
                                        </label>

                                        <span class="info-icon" :content="$t('order.servicingActionTechnicalInspectionTooltip')" v-tippy="{ placement : 'right',  arrow: true }">
                                            <img src="/img/info-icon.svg" class="info-icon">
                                        </span>

                                        <!--
                                        <transition name="fade">
                                            <div class="container" id="technical-inspection-container" v-if="serviceOperations.includes('technical-inspection')">
                                                <label for="technical-inspection-additional" style="font-weight: normal;font-size: 14px !important;">
                                                    <input type="checkbox" id="technical-inspection-additional" value="technical-inspection-additional" v-model="serviceOperationsTechnicalInspectionAdditional">
                                                    {{ $t('order.servicingActionTechnicalInspectionAdditional') }}
                                                </label>
                                                <div style="margin-top: 5px !important;" class="validation" v-show="!validations.serviceOperationsTechnicalInspectionAdditional.is_valid">{{ validations.serviceOperationsTechnicalInspectionAdditional.text }}</div>
                                            </div>
                                        </transition>
                                        -->
                                    </li>

                                    <li v-if="this.makeId">
                                        <label for="calling-action">
                                            <input type="checkbox" id="calling-action" value="calling-action" v-model="serviceOperations" onclick="return false;">
                                            <span class="checkbox-label">{{ $t('order.servicingActionCallingActionLabel') }}</span>
                                        </label>

                                        <span class="info-icon" :content="$t('order.servicingActionCallingActionTooltip')" v-tippy="{ placement : 'right',  arrow: true }">
                                            <img src="/img/info-icon.svg" class="info-icon">
                                        </span>
                                    </li>
                                </ul>
                            </div>

                            <div class="large-6 medium-6 small-12 cell">
                                <ul class="service-operations-list">
                                    <li v-if="this.maintenanceIncluded == true">
                                        <label for="service-oil-change">
                                            <input type="checkbox" id="service-oil-change" value="service-oil-change" v-model="serviceOperations">
                                            <span class="checkbox-label">{{ $t('order.servicingActionServiceOilChangeLabel') }}</span>
                                        </label>

                                        <span class="info-icon" :content="$t('order.servicingActionServiceOilChangeTooltip')" v-tippy="{ placement : 'right',  arrow: true }">
                                            <img src="/img/info-icon.svg" class="info-icon">
                                        </span>
                                    </li>

                                    <li v-if="this.maintenanceIncluded == true">
                                        <label for="breakdown">
                                            <input type="checkbox" id="breakdown" value="breakdown" v-model="serviceOperations">
                                            <span class="checkbox-label">{{ $t('order.servicingActionBreakdownLabel') }}</span>
                                        </label>

                                        <span class="info-icon" :content="$t('order.servicingActionBreakdownTooltip')" v-tippy="{ placement : 'right',  arrow: true }">
                                            <img src="/img/info-icon.svg" class="info-icon">
                                        </span>

                                        <transition name="fade">
                                            <div class="container" id="breakdown-text-container" v-if="serviceOperations.includes('breakdown')">
                                                <textarea rows="2" class="text-input" v-model="serviceOperationsBreakdownText" v-bind:class="{ 'invalid' : !validations.serviceOperationsBreakdownText.is_valid }" :placeholder="$t('order.servicingActionInputTextPlaceholder')"></textarea>
                                                <div class="validation" v-show="!validations.serviceOperationsBreakdownText.is_valid">{{ validations.serviceOperationsBreakdownText.text }}</div>
                                            </div>
                                        </transition>
                                    </li>

                                    <li v-if="this.maintenanceIncluded == true">
                                        <label for="other">
                                            <input type="checkbox" id="other" value="other" v-model="serviceOperations">
                                            <span class="checkbox-label">{{ $t('order.servicingActionOtherLabel') }}</span>
                                        </label>

                                        <span class="info-icon" :content="$t('order.servicingActionOtherTooltip')" v-tippy="{ placement : 'right',  arrow: true }">
                                            <img src="/img/info-icon.svg" class="info-icon">
                                        </span>

                                        <transition name="fade">
                                            <div class="container" id="other-text-container" v-if="serviceOperations.includes('other')">
                                                <textarea rows="2" class="text-input" v-model="serviceOperationsOtherText" v-bind:class="{ 'invalid' : !validations.serviceOperationsOtherText.is_valid }" :placeholder="$t('order.servicingActionInputTextPlaceholder')"></textarea>
                                                <div class="validation" v-show="!validations.serviceOperationsOtherText.is_valid">{{ validations.serviceOperationsOtherText.text }}</div>
                                            </div>
                                        </transition>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid-x grid-padding-x" v-if="serviceLoadStatus == 2 && (this.service.pickup_included || this.serviceSlotDefinition.pickup_included || this.service.replacement_car_included || service.replacement_car_included == false || this.serviceSlotDefinition.replacement_car_included || this.service.car_wash_included || this.serviceSlotDefinition.car_wash_included)">
                    <div class="large-8 medium-9 small-12 cell centered">
                        <div class="grid-x grid-padding-x">
                            <div class="large-12 medium-12 small-12 cell">
                                <h5 class="section-title">{{ $t('order.supplementaryServicesSectionLabel') }}</h5>

                                <ul class="extended-services-operations-list">
                                    <li v-if="(this.service.pickup_included == true && this.slotDefinition == false) || (this.serviceSlotDefinition.pickup_included == true && this.slotDefinition == true)">
                                        <label for="pick-up">
                                            <input type="checkbox" id="pick-up" value="pick-up" v-model="extendedServicesOperations" @change="extendedServicesPickupChanged">
                                            <span class="checkbox-label">{{ $t('order.supplementaryServicesPickUpLabel') }}</span>
                                        </label>

                                        <transition name="fade">
                                            <div class="container" id="pick-up-text-container" v-if="extendedServicesOperations.includes('pick-up')">
                                                <div class="grid-x grid-padding-x">
                                                    <div class="large-6 medium-12 small-12 cell">
                                                        <label class="form-label required">{{ $t('order.supplementaryServicesPickUpStreetLabel') }}</label>
                                                        <input type="text" v-model="pickupStreet" class="form-input" />
                                                        <div class="validation" v-show="!validations.pickupStreet.is_valid">{{ validations.pickupStreet.text }}</div>
                                                    </div>
                                                    <div class="large-3 medium-6 small-12 cell">
                                                        <label class="form-label required">{{ $t('order.supplementaryServicesPickUpTownLabel') }}</label>
                                                        <input type="text" v-model="pickupTown" class="form-input" />
                                                        <div class="validation" v-show="!validations.pickupTown.is_valid">{{ validations.pickupTown.text }}</div>
                                                    </div>
                                                    <div class="large-3 medium-6 small-12 cell">
                                                        <label class="form-label required">{{ $t('order.supplementaryServicesPickUpZipLabel') }}</label>
                                                        <input type="text" v-model="pickupZip" v-on:keypress="validNumber" maxlength="7" class="form-input" />
                                                        <div class="validation" v-show="!validations.pickupZip.is_valid">{{ validations.pickupZip.text }}</div>
                                                    </div>
                                                </div>
                                                <div class="grid-x grid-padding-x">
                                                    <div class="large-12 medium-6 small-12 cell">
                                                        <div class="validation" v-show="!validations.pickupGeocode.is_valid">{{ validations.pickupGeocode.text }}</div>
                                                    </div>
                                                </div>

                                                <!--
                                                <div class="grid-x grid-padding-x">
                                                    <div class="large-6 medium-6 small-12 cell centered">
                                                        <label class="form-label">Poznámka</label>
                                                        <input type="text" v-model="pickupNote" class="form-input" />
                                                    </div>
                                                </div>
                                                -->

                                                <!--
                                                <span class="service-info-text" v-if="(this.service.pickup_included == true && this.service.pickup_cond == 1) || (this.serviceSlotDefinition.pickup_included == true && this.serviceSlotDefinition.pickup_cond == 1)">
                                                    Služba Pick-up je zdarma pouze do vzdálenosti 20 km.
                                                </span>
                                                -->
                                            </div>
                                        </transition>
                                    </li>

                                    <li v-if="(this.service.replacement_car_included == true && this.slotDefinition == false) || (this.service.replacement_car_included == false && this.slotDefinition == false) || (this.serviceSlotDefinition.replacement_car_included == true && this.slotDefinition == true)">
                                        <label for="replacement-car" style="color: #8d8c8c !important;" v-if="extendedServicesDeniedReplacementVehicleCodes.includes(this.replCarEntitlementCode)">
                                            <input type="checkbox" id="replacement-car" value="replacement-car" v-model="extendedServicesOperations" :disabled="extendedServicesDeniedReplacementVehicleCodes.includes(this.replCarEntitlementCode) ? true : false">
                                            <span class="checkbox-label">{{ $t('order.supplementaryServicesReplacementCarLabel') }} ({{ $t('order.supplementaryServicesNotAgreed') }})</span>
                                        </label>
                                        <label for="replacement-car" v-else>
                                            <input type="checkbox" id="replacement-car" value="replacement-car" v-model="extendedServicesOperations">
                                            <span class="checkbox-label">{{ $t('order.supplementaryServicesReplacementCarLabel') }}</span>
                                        </label>

                                        <transition name="fade">
                                            <div class="container" id="replacement-car-container" v-if="extendedServicesOperations.includes('replacement-car')">
                                                <label for="replacement-car-additional" style="font-weight: normal;font-size: 14px !important;">
                                                    <input type="checkbox" id="replacement-car-additional" value="replacement-car-additional" v-model="extendedServicesOperationsReplacementCarAdditional">
                                                    <span class="checkbox-label">{{ $t('order.supplementaryServicesReplacementCarAdditional')}}</span>
                                                </label>
                                            </div>
                                        </transition>
                                    </li>

                                    <!--
                                    <li v-if="(this.service.car_wash_included == true && this.slotDefinition == false) || (this.serviceSlotDefinition.car_wash_included == true && this.slotDefinition == true)">
                                        <label for="car-wash">
                                            <input type="checkbox" id="car-wash" value="car-wash" v-model="extendedServicesOperations">
                                            <span class="checkbox-label">{{ $t('order.supplementaryServicesCarWashLabel') }}</span>
                                        </label>
                                    </li>
                                    -->
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid-x grid-padding-x" v-if="serviceLoadStatus == 2 && (this.service.maintenance_slot == true && !this.makeId)">
                    <div class="large-8 medium-9 small-12 cell centered" style="margin-bottom: 100px;">
                        <div class="grid-x grid-padding-x">
                            <div class="large-12 medium-12 small-12 cell">
                                <h5 class="section-title">{{ $t('order.selectionDateSectionLabel') }}</h5>

                                <div class="validation" style="text-align: center;" v-show="!validations.selectedSlot.is_valid">{{ validations.selectedSlot.text }}</div>

                                <loader v-show="serviceSlotsLoadStatus == 1" :width="100" :height="100"></loader>

                                <vue-cal v-if="serviceSlotsLoadStatus == 2"
                                         ref="vuecal"
                                         :locale="$i18n.locale"
                                         hide-view-selector
                                         active-view="week"
                                         :disable-views="['years', 'year', 'month', 'day']"
                                         :time="false"
                                         :events="events"
                                         @event-focus="onEventFocus">
                                    <!--
                                    <template v-slot:weekday-heading="param">{{ param }}</template>
                                    -->

                                    <template v-slot:title="{ title, view }">
                                        {{ title }}
                                    </template>

                                    <template v-slot:arrow-prev>
                                        <span v-on:click="clickedPrevCal()">&nbsp;<i class="angle"></i>&nbsp;</span>
                                    </template>

                                    <template v-slot:arrow-next>
                                        <span v-on:click="clickedNextCal()">&nbsp;<i class="angle"></i>&nbsp;</span>
                                    </template>

                                    <template v-slot:weekday-heading="{ heading }">{{ heading.label.substring(0, 2) }} {{ heading.date.format('DD. MM.') }}</template>

                                    <template v-slot:event="{ event, view }">
                                        <div class="vuecal__event-title" :class="'slot-' + event.id"  :id="'slot-' + event.id" :ref="'slot-' + event.id" v-html="event.title" />
                                    </template>
                                </vue-cal>

                                <!--
                                <div v-for="serviceSlot in serviceSlots">
                                    <input type="radio" name="selectedSlot" :id="serviceSlot.id" :value="serviceSlot.id">
                                    <label :for="serviceSlot.id"><b>{{ formatDate(serviceSlot.date_from) }}</b> (Index zaznamu pro tento den: {{ serviceSlot.index }})</label>
                                </div>
                                -->
                            </div>
                        </div>
                    </div>

                    <div class="large-8 medium-9 small-12 cell centered">
                        <div class="grid-x grid-padding-x">
                            <div class="large-12 medium-12 small-12 cell">
                                <span class="selected-slot-text" v-if="this.selectedEvent.id">
                                    {{ $t('order.selectionDateSectionSelectedSlotFirst') }} {{ formatDate(this.selectedEvent.start) }} {{ $t('order.selectionDateSectionSelectedSlotSecond') }} {{ serviceSlotReservationTime }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="large-8 medium-9 small-12 cell centered">
                        <div class="grid-x grid-padding-x">
                            <div class="large-12 medium-12 small-12 cell">
                                <h5 class="section-title">{{ $t('order.selectionDateSectionTimeLabel') }}</h5>
                                <label class="form-label required" style="text-align: center;" v-if="extendedServicesOperations.includes('pick-up')">{{ $t('order.selectionDateSectionTimePickUp') }}</label>
                                <label class="form-label required" style="text-align: center;" v-else>{{ $t('order.selectionDateSectionTimeBrought') }}</label>
                                <v-select v-model="slotTime" :options="extendedServicesOperations.includes('pick-up') ? preferredDateTimeOptionsSel : preferredDateTimeSingleOptionsSel" :searchable="false" :clearable="false"></v-select>
                                <!--<date-picker v-model="slotTime" :time-picker-options="preferredDateTimeOptions" :clearable="false" format="HH:mm" value-type="format" type="time" placeholder="HH:mm"></date-picker>-->
                                <div class="validation" style="margin-top: 0px;text-align: center;" v-show="!validations.slotTime.is_valid">{{ validations.slotTime.text }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid-x grid-padding-x" v-if="serviceLoadStatus == 2 && ((this.service.maintenance_slot == false) || (this.service.maintenance_slot == true && this.makeId))">
                    <div class="large-8 medium-9 small-12 cell centered">
                        <h5 class="section-title" v-if="extendedServicesOperations.includes('pick-up')">{{ $t('order.termSectionPickupLabel') }}</h5>
                        <h5 class="section-title" v-else>{{ $t('order.termSectionServiceLabel') }}</h5>

                        <span class="section-description">{{ checkedDateType == 'preferred_dates' ? $t('order.termSectionPreferredDateDescription') : $t('order.termSectionPeriodDescription') }}</span>

                        <div class="radio-btn-group">
                            <div class="radio">
                                <input type="radio" name="radio-date-type" value="preferred_dates" v-model="checkedDateType" id="preferred_dates" />
                                <label for="preferred_dates">{{ $t('order.termSectionPreferredDatesLabel') }}</label>
                            </div>
                            <div class="radio">
                                <input type="radio" name="radio-date-type" value="period" v-model="checkedDateType" id="period" checked="checked" />
                                <label for="period">{{ $t('order.termSectionPeriodLabel') }}</label>
                            </div>
                        </div>

                        <div class="grid-x grid-padding-x" v-if="checkedDateType == 'preferred_dates'">
                            <div class="large-4 medium-4 small-12 cell">
                                <label class="form-label required" style="text-align: center;">1. {{ $t('order.termSectionPreferredDatesLabel') }}</label>
                                <date-picker v-model="preferredDate1" valueType="format" :formatter="momentFormat" :disabled-date="disableDatesBeforeToday" :editable="false" :clearable="false" :lang="$i18n.locale"></date-picker>
                                <v-select v-model="preferredDateTime1" :options="extendedServicesOperations.includes('pick-up') ? preferredDateTimeOptionsSel : preferredDateTimeSingleOptionsSel" :searchable="false" :clearable="false"></v-select>
                                <!--<date-picker v-model="preferredDateTime1" :time-picker-options="preferredDateTimeOptions" :clearable="false" format="HH:mm" value-type="format" type="time" placeholder="HH:mm"></date-picker>-->
                                <div class="validation" style="margin-top: 0px;text-align: center;" v-show="!validations.preferredDate1.is_valid">{{ validations.preferredDate1.text }}</div>
                            </div>
                            <div class="large-4 medium-4 small-12 cell">
                                <label class="form-label required" style="text-align: center;">2. {{ $t('order.termSectionPreferredDatesLabel') }}</label>
                                <date-picker v-model="preferredDate2" valueType="format" :formatter="momentFormat" :disabled-date="disableDatesBeforeToday" :editable="false" :clearable="false" :lang="$i18n.locale"></date-picker>
                                <v-select v-model="preferredDateTime2" :options="extendedServicesOperations.includes('pick-up') ? preferredDateTimeOptionsSel : preferredDateTimeSingleOptionsSel" :searchable="false" :clearable="false"></v-select>
                                <!--<date-picker v-model="preferredDateTime2" :time-picker-options="preferredDateTimeOptions" :clearable="false" format="HH:mm" value-type="format" type="time" placeholder="HH:mm"></date-picker>-->
                                <div class="validation" style="margin-top: 0px;text-align: center;" v-show="!validations.preferredDate2.is_valid">{{ validations.preferredDate2.text }}</div>
                            </div>
                            <div class="large-4 medium-4 small-12 cell">
                                <label class="form-label required" style="text-align: center;">3. {{ $t('order.termSectionPreferredDatesLabel') }}</label>
                                <date-picker v-model="preferredDate3" valueType="format" :formatter="momentFormat" :disabled-date="disableDatesBeforeToday" :editable="false" :clearable="false" :lang="$i18n.locale"></date-picker>
                                <v-select v-model="preferredDateTime3" :options="extendedServicesOperations.includes('pick-up') ? preferredDateTimeOptionsSel : preferredDateTimeSingleOptionsSel" :searchable="false" :clearable="false"></v-select>
                                <!--<date-picker v-model="preferredDateTime3" :time-picker-options="preferredDateTimeOptions" :clearable="false" format="HH:mm" value-type="format" type="time" placeholder="HH:mm"></date-picker>-->
                                <div class="validation" style="margin-top: 0px;text-align: center;" v-show="!validations.preferredDate3.is_valid">{{ validations.preferredDate3.text }}</div>
                            </div>
                        </div>

                        <div class="grid-x grid-padding-x" v-if="checkedDateType == 'period'">
                            <div class="large-12 medium-12 small-12 cell preferred-date-period">
                                <label class="form-label required" style="text-align: center;">{{ $t('order.termSectionPeriodLabel') }}</label>
                                <date-picker v-model="preferredDatePeriod" style="text-align: center;" valueType="format" range range-separator=" - " :formatter="momentFormat" :editable="false" :disabled-date="disableDatesBeforeTodayPeriod" :clearable="false" :lang="$i18n.locale" @pick="preferredDatePeriodPick"></date-picker>
                                <div class="validation" style="text-align: center;" v-show="!validations.preferredDatePeriod.is_valid">{{ validations.preferredDatePeriod.text }}</div>
                            </div>

                            <div class="large-12 medium-12 small-12 cell preferred-date-period">
                                <label class="form-label required" style="text-align: center;">{{ $t('order.termSectionTimeLabel') }}</label>
                                <v-select v-model="preferredDatePeriodFrom" :options="extendedServicesOperations.includes('pick-up') ? preferredDateTimeOptionsSel : preferredDateTimeSingleOptionsSel" :searchable="false" :clearable="false"></v-select>
                                <!--<date-picker v-model="preferredDatePeriodFrom" :time-picker-options="preferredDateTimeOptions" :clearable="false" format="HH:mm" value-type="format" type="time" placeholder="HH:mm"></date-picker>-->
                                <div class="validation" style="margin-top: 0px;text-align: center;" v-show="!validations.preferredDatePeriodFrom.is_valid">{{ validations.preferredDatePeriodFrom.text }}</div>
                            </div>
                        </div>

                        <div class="grid-x grid-padding-x" v-if="checkedDateType == 'preferred_dates' || checkedDateType == 'period'">
                            <div class="large-12 medium-12 small-12 cell">
                                <div class="form-group">
                                    <label class="font-weight-bold d-block" style="display: block!important;text-align: center;font-weight: bold;margin-bottom: 10px;margin-top: 20px;">{{ $t('order.serviceSupplierLocation') }}</label>

                                    <fieldset class="checkbox-option-wrapper">
                                        <div class="custom-control custom-radio checkbox-option-container">
                                            <input type="radio" name="type" id="service-supplier-location-yes" value="true" v-model="serviceSupplierLocation" class="checkbox-option-label">
                                            <label for="service-supplier-location-yes" class="checkbox-option-label checkbox-option-label-small">
                                                <div class="checkbox-option-dot"></div>
                                                <span>{{ $t('general.yes') }}</span>
                                            </label>
                                        </div>

                                        <div class="custom-control custom-radio checkbox-option-container">
                                            <input type="radio" name="type" id="service-supplier-location-no" value="false" v-model="serviceSupplierLocation" class="checkbox-option-label">
                                            <label for="service-supplier-location-no" class="checkbox-option-label checkbox-option-label-small">
                                                <div class="checkbox-option-dot"></div>
                                                <span>{{ $t('general.no') }}</span>
                                            </label>
                                        </div>
                                    </fieldset>

                                    <div style="margin-top: 5px !important;text-align: center;" class="validation" v-show="!validations.serviceSupplierLocation.is_valid">{{ validations.serviceSupplierLocation.text }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid-x grid-padding-x" v-if="serviceLoadStatus == 2">
                    <div class="large-8 medium-9 small-12 cell centered">
                        <div class="grid-x grid-padding-x">
                            <div class="large-12 medium-12 small-12 cell">
                                <span class="bottom-security-text">
                                    {{ $t('order.securityInfoFirst') }} <a :href="$t('order.securityInfoLink')" target="_blank">{{ $t('order.securityInfoSecond') }}</a>.
                                    <br />
                                    {{ $t('order.mandatoryInfoFirst') }} <span class="mandatory">*</span> {{ $t('order.mandatoryInfoSecond') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid-x grid-padding-x" v-if="serviceLoadStatus == 2">
                    <div class="large-4 medium-5 small-12 cell centered">
                        <loader v-show="orderFormSentStatus == 1" :width="100" :height="100"></loader>
                        <a class="order-button" v-show="orderFormSentStatus != 1" v-on:click="submitOrderService()">{{ $t('order.submitFormButton') }}</a>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import moment from 'moment'
    import API from "../api/service";
    import Geocode from "../api/geocode";
    import Loader from "../components/global/Loader";
    import VueCal from 'vue-cal'
    import 'vue-cal/dist/vuecal.css'
    import 'vue-cal/dist/i18n/cs.js'
    import Vue from "vue";
    import VueTippy, { TippyComponent } from "vue-tippy";
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import 'vue2-datepicker/locale/cs';
    import VuePhoneNumberInput from 'vue-phone-number-input';
    import 'vue-phone-number-input/dist/vue-phone-number-input.css';
    import "vue-select/dist/vue-select.css";
    import vSelect from "vue-select";
    import {EventBus} from "../event-bus";
    import {ROAST_CONFIG} from "../config";

    Vue.use(VueTippy);
    Vue.component('tippy', TippyComponent);
    Vue.component("v-select", vSelect);

    export default {
        components: {
            Loader,
            VueCal,
            DatePicker,
            VuePhoneNumberInput
        },

        data() {
            return {
                momentFormat: {
                    // Date to String
                    stringify: (date) => {
                        return date ? moment(date).format('DD.MM.YYYY') : ''
                    },
                    // String to Date
                    parse: (value) => {
                        return value ? moment(value, 'DD.MM.YYYY').toDate() : null
                    }
                },

                app_env: ROAST_CONFIG.APP_ENV,

                enabledSlotReservationCounter: false,
                slotReservationCountdown: moment(180 * 10 * 1000),

                selectedEvent: {},
                events: [],
                slotTime: '8:00',

                serviceName: '',
                companyID: '',

                license: '',
                mileage: '',
                firstName: '',
                lastName: '',
                emailAddress: '',

                phoneNumber: '',
                phoneNumberResults: {},
                phoneNumberOnlyCountries: ['CZ', 'SK'],
                phoneNumberTranslations: {
                    countrySelectorLabel: this.$t('order.phoneCountryCode'),
                    countrySelectorError: this.$t('order.phoneSelectCountry'),
                    phoneNumberLabel: this.$t('order.phoneNumberPlaceholder'),
                    example: this.$t('order.phoneNumberExample')
                },

                checkedDateType: 'period',
                preferredDateTimeOptions: {
                    start: '08:00',
                    step: '00:30',
                    end: '10:00',
                },
                preferredDate1: '',
                preferredDateTime1: '8:00',
                preferredDate2: '',
                preferredDateTime2: '8:00',
                preferredDate3: '',
                preferredDateTime3: '8:00',
                preferredDatePeriod: '',
                preferredDatePeriodFrom: '8:00',

                preferredDateTimeOptionsSel: [
                    '8:00 - 8:30',
                    '8:30 - 9:00',
                    '9:00 - 9:30',
                    '9:30 - 10:00',
                ],

                preferredDateTimeSingleOptionsSel: [
                    '8:00',
                    '8:30',
                    '9:00',
                    '9:30',
                    '10:00',
                ],

                serviceOperations: [],
                serviceOperationsRepairText: '',
                serviceOperationsTechnicalInspectionAdditional: true,
                serviceOperationsBreakdownText: '',
                serviceOperationsOtherText: '',
                serviceSupplierLocation: '',

                extendedServicesOperations: [],
                extendedServicesOperationsText: '',
                extendedServicesOperationsReplacementCarAdditional: false,
                extendedServicesDeniedReplacementVehicleCodes: ['Z', 'N'],

                pickupNote: '',
                pickupStreet: '',
                pickupTown: '',
                pickupZip: '',

                slotDefinition: false,

                validations: {
                    mileage: {
                        is_valid: true,
                        text: ''
                    },
                    firstName: {
                        is_valid: true,
                        text: ''
                    },
                    lastName: {
                        is_valid: true,
                        text: ''
                    },
                    emailAddress: {
                        is_valid: true,
                        text: ''
                    },
                    phoneNumber: {
                        is_valid: true,
                        text: ''
                    },
                    selectedSlot: {
                        is_valid: true,
                        text: ''
                    },
                    slotTime: {
                        is_valid: true,
                        text: ''
                    },
                    preferredDate1: {
                        is_valid: true,
                        text: ''
                    },
                    preferredDate2: {
                        is_valid: true,
                        text: ''
                    },
                    preferredDate3: {
                        is_valid: true,
                        text: ''
                    },
                    preferredDatePeriod: {
                        is_valid: true,
                        text: ''
                    },
                    preferredDatePeriodFrom: {
                        is_valid: true,
                        text: ''
                    },
                    serviceOperations: {
                        is_valid: true,
                        text: ''
                    },
                    serviceOperationsRepairText: {
                        is_valid: true,
                        text: ''
                    },
                    serviceOperationsTechnicalInspectionAdditional: {
                        is_valid: true,
                        text: ''
                    },
                    serviceOperationsBreakdownText: {
                        is_valid: true,
                        text: ''
                    },
                    serviceOperationsOtherText: {
                        is_valid: true,
                        text: ''
                    },
                    serviceSupplierLocation: {
                        is_valid: true,
                        text: ''
                    },
                    pickupStreet: {
                        is_valid: true,
                        text: ''
                    },
                    pickupTown: {
                        is_valid: true,
                        text: ''
                    },
                    pickupZip: {
                        is_valid: true,
                        text: ''
                    },
                    pickupGeocode: {
                        is_valid: true,
                        text: ''
                    }
                }
            }
        },

        mounted() {
            this.$selectedSlot = null;
            this.$selectedSlotId = null;
            this.$selectedSlotDate = null;
        },

        created() {
            if (this.clientLocation) {
                this.loadService();
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(position => {
                        this.setClientLocation(position);
                    }, err => {
                        console.log('User denied Geolocation');
                        this.$router.push({ name: 'services' });
                    }, {
                        enableHighAccuracy: true,
                        timeout: 60000
                    });
                }
            }

            if (this.makeId) {
                this.serviceOperations = ['calling-action'];
            }
        },

        computed: {
            clientLocation() {
                return this.$store.getters.getClientLocation;
            },

            licensePlate() {
                return this.$store.getters.getLicensePlate;
            },

            clientPersonalData() {
                return this.$store.getters.getClientPersonalData;
            },

            workroom() {
                return this.$store.getters.getWorkroom;
            },

            makeId() {
                return this.$store.getters.getMakeId;
            },

            maintenanceIncluded() {
                return this.$store.getters.getMaintenanceIncluded;
            },

            distance() {
                return this.$store.getters.getDistanceFilter;
            },

            serviceLoadStatus() {
                return this.$store.getters.getServiceLoadStatus;
            },

            service() {
                return this.$store.getters.getService;
            },

            serviceSlotDefinition() {
                return this.$store.getters.getServiceSlotDefnition;
            },

            serviceSlots() {
                return this.$store.getters.getServiceSlots;
            },

            serviceSlotsLoadStatus() {
                return this.$store.getters.getServiceSlotsLoadStatus;
            },

            serviceBlockSlotLoadStatus() {
                return this.$store.getters.getBlockServiceSlotLoadStatus;
            },

            serviceSlotBlockUntil() {
                return this.$store.getters.getBlockServiceSlotUntil;
            },

            orderFormSentStatus() {
                return this.$store.getters.getOrderFormSentStatus;
            },

            serviceSlotReservationTime: function() {
                return this.slotReservationCountdown.format('mm:ss');
            },

            replCarEntitlementCode() {
                return this.$store.getters.getReplCarEntitlementCode;
            }
        },

        watch: {
            'serviceLoadStatus': function() {
                if (this.serviceLoadStatus == 2) {
                    this.loadServiceSlotDefinition();
                    this.loadServiceSlots();
                    this.populateForm();
                }
            },

            'serviceSlotsLoadStatus': function() {
                if (this.serviceSlotsLoadStatus == 2) {
                    this.serviceSlots.forEach((value, index) => {
                        this.events.push(value);
                        //this.customEventCreation(value);
                    });
                }
            },

            'serviceBlockSlotLoadStatus' : function () {
                if (this.serviceBlockSlotLoadStatus == 2) {
                    //this.slotReservationCountdown = moment(this.serviceSlotBlockUntil * 1000);
                } else if (this.serviceBlockSlotLoadStatus == 3) {
                    this.$store.dispatch('flashMessageShow', { type: 'info', message: this.$t('order.selectionDateSectionAlreadyReserved') }, { root: true })

                    this.selectedEvent = {};
                    this.events = [];
                    this.$selectedSlot = null;
                    this.$selectedSlotId = null;
                    this.$selectedSlotDate = null;

                    this.loadServiceSlots();
                }
            },

            'selectedEvent': function() {
                // event selected
            },

            'slotReservationCountdown': function() {
                if (this.serviceSlotReservationTime == '00:00') {
                    this.selectedEvent = {};
                    this.events = [];
                    this.$selectedSlot = null;
                    this.$selectedSlotId = null;
                    this.$selectedSlotDate = null;

                    this.loadServiceSlots();
                }
            },

            'orderFormSentStatus': function() {
                if (this.orderFormSentStatus == 2) {
                    this.$store.dispatch('flashMessageShow', { type: 'success', message: this.$t('order.successFormSubmit') }, { root: true })

                    this.$router.push({ name: 'services' });
                } else if (this.orderFormSentStatus == 3) {
                    this.$store.dispatch('flashMessageShow', { type: 'error', message: this.$t('order.errorFormSubmit') }, { root: true })
                }
            },
        },

        methods: {
            setClientLocation(position) {
                Geocode.getCountryCodeFromPosition(position)
                    .then((response) => {
                        if (response != 'CZ') {
                            this.$store.commit('setClientCurrentLocation', { location: { latitude: 50.08804, longitude: 14.42076 } })
                        } else {
                            this.$store.commit('setClientCurrentLocation', { location: { latitude: position.coords.latitude, longitude: position.coords.longitude } })
                        }

                        this.loadService();
                    })
                    .catch((error) => {
                        console.log(error)
                    });
            },

            loadService() {
                this.$store.dispatch('loadService', {
                    slug: this.$route.params.slug,
                    distance: this.distance,
                    workroom: this.workroom,
                    makeId: this.makeId,
                    licensePlate: this.licensePlate,
                    latitude: this.clientLocation.latitude,
                    longitude: this.clientLocation.longitude
                });
            },

            loadServiceSlotDefinition() {
                this.$store.commit('setServiceSlotDefinition', {});

                if (this.service.maintenance_slot && !this.makeId) {
                    this.$store.dispatch('loadServiceSlotDefinition', {
                        workroom_id: this.service.workroom_id
                    });

                    this.slotDefinition = true;
                }
            },

            loadServiceSlots() {
                this.$store.commit('setServiceSlots', []);

                if (this.service.maintenance_slot && !this.makeId) {
                    this.$store.dispatch('loadServiceSlots', {
                        workroom_id: this.service.workroom_id,
                        workroom: this.workroom
                    });
                }
            },

            extendedServicesPickupChanged() {
                if (this.extendedServicesOperations.includes('pick-up')) {
                    (this.slotTime == '8:00' ? this.slotTime = '8:00 - 8:30' : (this.slotTime == '8:30' ? this.slotTime = '8:30 - 9:00' : (this.slotTime == '9:00' ? this.slotTime = '9:00 - 9:30' : (this.slotTime == '9:30' ? this.slotTime = '9:30 - 10:00' : (this.slotTime == '10:00' ? this.slotTime = '9:30 - 10:00' : null)))));

                    (this.preferredDateTime1 == '8:00' ? this.preferredDateTime1 = '8:00 - 8:30' : (this.preferredDateTime1 == '8:30' ? this.preferredDateTime1 = '8:30 - 9:00' : (this.preferredDateTime1 == '9:00' ? this.preferredDateTime1 = '9:00 - 9:30' : (this.preferredDateTime1 == '9:30' ? this.preferredDateTime1 = '9:30 - 10:00' : (this.preferredDateTime1 == '10:00' ? this.preferredDateTime1 = '9:30 - 10:00' : null)))));
                    (this.preferredDateTime2 == '8:00' ? this.preferredDateTime2 = '8:00 - 8:30' : (this.preferredDateTime2 == '8:30' ? this.preferredDateTime2 = '8:30 - 9:00' : (this.preferredDateTime2 == '9:00' ? this.preferredDateTime2 = '9:00 - 9:30' : (this.preferredDateTime2 == '9:30' ? this.preferredDateTime2 = '9:30 - 10:00' : (this.preferredDateTime2 == '10:00' ? this.preferredDateTime2 = '9:30 - 10:00' : null)))));
                    (this.preferredDateTime3 == '8:00' ? this.preferredDateTime3 = '8:00 - 8:30' : (this.preferredDateTime3 == '8:30' ? this.preferredDateTime3 = '8:30 - 9:00' : (this.preferredDateTime3 == '9:00' ? this.preferredDateTime3 = '9:00 - 9:30' : (this.preferredDateTime3 == '9:30' ? this.preferredDateTime3 = '9:30 - 10:00' : (this.preferredDateTime3 == '10:00' ? this.preferredDateTime3 = '9:30 - 10:00' : null)))));

                    (this.preferredDatePeriodFrom == '8:00' ? this.preferredDatePeriodFrom = '8:00 - 8:30' : (this.preferredDatePeriodFrom == '8:30' ? this.preferredDatePeriodFrom = '8:30 - 9:00' : (this.preferredDatePeriodFrom == '9:00' ? this.preferredDatePeriodFrom = '9:00 - 9:30' : (this.preferredDatePeriodFrom == '9:30' ? this.preferredDatePeriodFrom = '9:30 - 10:00' : (this.preferredDatePeriodFrom == '10:00' ? this.preferredDatePeriodFrom = '9:30 - 10:00' : null)))));
                } else {
                    (this.slotTime == '8:00 - 8:30' ? this.slotTime = '8:00' : (this.slotTime == '8:30 - 9:00' ? this.slotTime = '8:30' : (this.slotTime == '9:00 - 9:30' ? this.slotTime = '9:00' : (this.slotTime == '9:30 - 10:00' ? this.slotTime = '9:30' : null))));

                    (this.preferredDateTime1 == '8:00 - 8:30' ? this.preferredDateTime1 = '8:00' : (this.preferredDateTime1 == '8:30 - 9:00' ? this.preferredDateTime1 = '8:30' : (this.preferredDateTime1 == '9:00 - 9:30' ? this.preferredDateTime1 = '9:00' : (this.preferredDateTime1 == '9:30 - 10:00' ? this.preferredDateTime1 = '9:30' : null))));
                    (this.preferredDateTime2 == '8:00 - 8:30' ? this.preferredDateTime2 = '8:00' : (this.preferredDateTime2 == '8:30 - 9:00' ? this.preferredDateTime2 = '8:30' : (this.preferredDateTime2 == '9:00 - 9:30' ? this.preferredDateTime2 = '9:00' : (this.preferredDateTime2 == '9:30 - 10:00' ? this.preferredDateTime2 = '9:30' : null))));
                    (this.preferredDateTime3 == '8:00 - 8:30' ? this.preferredDateTime3 = '8:00' : (this.preferredDateTime3 == '8:30 - 9:00' ? this.preferredDateTime3 = '8:30' : (this.preferredDateTime3 == '9:00 - 9:30' ? this.preferredDateTime3 = '9:00' : (this.preferredDateTime3 == '9:30 - 10:00' ? this.preferredDateTime3 = '9:30' : null))));

                    (this.preferredDatePeriodFrom == '8:00 - 8:30' ? this.preferredDatePeriodFrom = '8:00' : (this.preferredDatePeriodFrom == '8:30 - 9:00' ? this.preferredDatePeriodFrom = '8:30': (this.preferredDatePeriodFrom == '9:00 - 9:30' ? this.preferredDatePeriodFrom = '9:00' : (this.preferredDatePeriodFrom == '9:30 - 10:00' ? this.preferredDatePeriodFrom = '9:30' : null))));
                }
            },

            disableDatesBeforeToday(date) {
                const day = new Date(date).getDay()

                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const tomorrow = new Date(today);
                tomorrow.setDate(tomorrow.getDate() + 1);

                const tomorrowPlusOne = new Date(today);
                tomorrowPlusOne.setDate(tomorrowPlusOne.getDate() + 7);

                const tomorrowPlusTwo = new Date(today);
                tomorrowPlusTwo.setDate(tomorrowPlusTwo.getDate() + 8);

                const tomorrowPlusThree = new Date(today);
                tomorrowPlusThree.setDate(tomorrowPlusThree.getDate() + 9);

                const calDay = new Date(date);
                calDay.setHours(0, 0, 0, 0);
                calDay.setDate(calDay.getDate());

                var now = moment();

                if (this.preferredDate1 && this.preferredDate2 && this.preferredDate3) {
                    var parts123Plus1 = this.preferredDate1.split('.');
                    const selDay123Plus1 = new Date(parts123Plus1[2], parts123Plus1[1] - 1, parts123Plus1[0]);
                    selDay123Plus1.setHours(0, 0, 0, 0);
                    selDay123Plus1.setDate(selDay123Plus1.getDate());

                    var parts123Plus2 = this.preferredDate2.split('.');
                    const selDay123Plus2 = new Date(parts123Plus2[2], parts123Plus2[1] - 1, parts123Plus2[0]);
                    selDay123Plus2.setHours(0, 0, 0, 0);
                    selDay123Plus2.setDate(selDay123Plus2.getDate());

                    var parts123Plus3 = this.preferredDate3.split('.');
                    const selDay123Plus3 = new Date(parts123Plus3[2], parts123Plus3[1] - 1, parts123Plus3[0]);
                    selDay123Plus3.setHours(0, 0, 0, 0);
                    selDay123Plus3.setDate(selDay123Plus3.getDate());

                    if (calDay.getTime() === selDay123Plus1.getTime() || calDay.getTime() === selDay123Plus2.getTime() || calDay.getTime() === selDay123Plus3.getTime()) {
                        return true;
                    } else {
                        if (now.hour() >= 10) {
                            if (now.isoWeekday() == 5) {
                                return date < tomorrowPlusThree || date > new Date(tomorrowPlusThree.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            } else {
                                //return date < tomorrowPlusOne || date > new Date(tomorrowPlusOne.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6;
                                return date < tomorrowPlusTwo || date > new Date(tomorrowPlusTwo.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            }
                        } else {
                            if (now.isoWeekday() == 5) {
                                return date < tomorrowPlusTwo || date > new Date(tomorrowPlusTwo.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            } else {
                                //return date < tomorrow || date > new Date(tomorrow.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6;
                                return date < tomorrowPlusOne || date > new Date(tomorrowPlusOne.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            }
                        }
                    }
                }

                if (this.preferredDate1 && this.preferredDate2) {
                    var parts12Plus = this.preferredDate1.split('.');
                    const selDay12Plus = new Date(parts12Plus[2], parts12Plus[1] - 1, parts12Plus[0]);
                    selDay12Plus.setHours(0, 0, 0, 0);
                    selDay12Plus.setDate(selDay12Plus.getDate());

                    var parts21Plus = this.preferredDate2.split('.');
                    const selDay21Plus = new Date(parts21Plus[2], parts21Plus[1] - 1, parts21Plus[0]);
                    selDay21Plus.setHours(0, 0, 0, 0);
                    selDay21Plus.setDate(selDay21Plus.getDate());

                    if (calDay.getTime() === selDay12Plus.getTime() || calDay.getTime() === selDay21Plus.getTime()) {
                        return true;
                    } else {
                        if (now.hour() >= 10) {
                            if (now.isoWeekday() == 5) {
                                return date < tomorrowPlusThree || date > new Date(tomorrowPlusThree.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            } else {
                                //return date < tomorrowPlusOne || date > new Date(tomorrowPlusOne.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6;
                                return date < tomorrowPlusTwo || date > new Date(tomorrowPlusTwo.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            }
                        } else {
                            if (now.isoWeekday() == 5) {
                                return date < tomorrowPlusTwo || date > new Date(tomorrowPlusTwo.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            } else {
                                //return date < tomorrow || date > new Date(tomorrow.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6;
                                return date < tomorrowPlusOne || date > new Date(tomorrowPlusOne.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            }
                        }
                    }
                }

                if (this.preferredDate1 && this.preferredDate3) {
                    var parts13Plus = this.preferredDate1.split('.');
                    const selDay13Plus = new Date(parts13Plus[2], parts13Plus[1] - 1, parts13Plus[0]);
                    selDay13Plus.setHours(0, 0, 0, 0);
                    selDay13Plus.setDate(selDay13Plus.getDate());

                    var parts31Plus = this.preferredDate3.split('.');
                    const selDay31Plus = new Date(parts31Plus[2], parts31Plus[1] - 1, parts31Plus[0]);
                    selDay31Plus.setHours(0, 0, 0, 0);
                    selDay31Plus.setDate(selDay31Plus.getDate());

                    if (calDay.getTime() === selDay13Plus.getTime() || calDay.getTime() === selDay31Plus.getTime()) {
                        return true;
                    } else {
                        if (now.hour() >= 10) {
                            if (now.isoWeekday() == 5) {
                                return date < tomorrowPlusThree || date > new Date(tomorrowPlusThree.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            } else {
                                //return date < tomorrowPlusOne || date > new Date(tomorrowPlusOne.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6;
                                return date < tomorrowPlusTwo || date > new Date(tomorrowPlusTwo.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            }
                        } else {
                            if (now.isoWeekday() == 5) {
                                return date < tomorrowPlusTwo || date > new Date(tomorrowPlusTwo.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            } else {
                                //return date < tomorrow || date > new Date(tomorrow.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6;
                                return date < tomorrowPlusOne || date > new Date(tomorrowPlusOne.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            }
                        }
                    }
                }

                if (this.preferredDate2 && this.preferredDate3) {
                    var parts23Plus = this.preferredDate2.split('.');
                    const selDay23Plus = new Date(parts23Plus[2], parts23Plus[1] - 1, parts23Plus[0]);
                    selDay23Plus.setHours(0, 0, 0, 0);
                    selDay23Plus.setDate(selDay23Plus.getDate());

                    var parts32Plus = this.preferredDate3.split('.');
                    const selDay32Plus = new Date(parts32Plus[2], parts32Plus[1] - 1, parts32Plus[0]);
                    selDay32Plus.setHours(0, 0, 0, 0);
                    selDay32Plus.setDate(selDay32Plus.getDate());

                    if (calDay.getTime() === selDay23Plus.getTime() || calDay.getTime() === selDay32Plus.getTime()) {
                        return true;
                    } else {
                        if (now.hour() >= 10) {
                            if (now.isoWeekday() == 5) {
                                return date < tomorrowPlusThree || date > new Date(tomorrowPlusThree.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            } else {
                                //return date < tomorrowPlusOne || date > new Date(tomorrowPlusOne.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6;
                                return date < tomorrowPlusTwo || date > new Date(tomorrowPlusTwo.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            }
                        } else {
                            if (now.isoWeekday() == 5) {
                                return date < tomorrowPlusTwo || date > new Date(tomorrowPlusTwo.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            } else {
                                //return date < tomorrow || date > new Date(tomorrow.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6;
                                return date < tomorrowPlusOne || date > new Date(tomorrowPlusOne.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            }
                        }
                    }
                }

                if (this.preferredDate1) {
                    var parts1Plus = this.preferredDate1.split('.');
                    const selDay1Plus = new Date(parts1Plus[2], parts1Plus[1] - 1, parts1Plus[0]);
                    selDay1Plus.setHours(0, 0, 0, 0);
                    selDay1Plus.setDate(selDay1Plus.getDate());

                    if (calDay.getTime() === selDay1Plus.getTime()) {
                        return true;
                    } else {
                        if (now.hour() >= 10) {
                            if (now.isoWeekday() == 5) {
                                return date < tomorrowPlusThree || date > new Date(tomorrowPlusThree.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            } else {
                                //return date < tomorrowPlusOne || date > new Date(tomorrowPlusOne.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6;
                                return date < tomorrowPlusTwo || date > new Date(tomorrowPlusTwo.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            }
                        } else {
                            if (now.isoWeekday() == 5) {
                                return date < tomorrowPlusTwo || date > new Date(tomorrowPlusTwo.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            } else {
                                //return date < tomorrow || date > new Date(tomorrow.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6;
                                return date < tomorrowPlusOne || date > new Date(tomorrowPlusOne.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            }
                        }
                    }
                }

                if (this.preferredDate2) {
                    var parts2Plus = this.preferredDate2.split('.');
                    const selDay2Plus = new Date(parts2Plus[2], parts2Plus[1] - 1, parts2Plus[0]);
                    selDay2Plus.setHours(0, 0, 0, 0);
                    selDay2Plus.setDate(selDay2Plus.getDate());

                    if (calDay.getTime() === selDay2Plus.getTime()) {
                        return true;
                    } else {
                        if (now.hour() >= 10) {
                            if (now.isoWeekday() == 5) {
                                return date < tomorrowPlusThree || date > new Date(tomorrowPlusThree.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            } else {
                                //return date < tomorrowPlusOne || date > new Date(tomorrowPlusOne.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6;
                                return date < tomorrowPlusTwo || date > new Date(tomorrowPlusTwo.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            }
                        } else {
                            if (now.isoWeekday() == 5) {
                                return date < tomorrowPlusTwo || date > new Date(tomorrowPlusTwo.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            } else {
                                //return date < tomorrow || date > new Date(tomorrow.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6;
                                return date < tomorrowPlusOne || date > new Date(tomorrowPlusOne.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            }
                        }
                    }
                }

                if (this.preferredDate3) {
                    var parts3Plus = this.preferredDate3.split('.');
                    const selDay3Plus = new Date(parts3Plus[2], parts3Plus[1] - 1, parts3Plus[0]);
                    selDay3Plus.setHours(0, 0, 0, 0);
                    selDay3Plus.setDate(selDay3Plus.getDate());

                    if (calDay.getTime() === selDay3Plus.getTime()) {
                        return true;
                    } else {
                        if (now.hour() >= 10) {
                            if (now.isoWeekday() == 5) {
                                return date < tomorrowPlusThree || date > new Date(tomorrowPlusThree.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            } else {
                                //return date < tomorrowPlusOne || date > new Date(tomorrowPlusOne.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6;
                                return date < tomorrowPlusTwo || date > new Date(tomorrowPlusTwo.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            }
                        } else {
                            if (now.isoWeekday() == 5) {
                                return date < tomorrowPlusTwo || date > new Date(tomorrowPlusTwo.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            } else {
                                //return date < tomorrow || date > new Date(tomorrow.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6;
                                return date < tomorrowPlusOne || date > new Date(tomorrowPlusOne.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                            }
                        }
                    }
                }

                if (now.hour() >= 10) {
                    if (now.isoWeekday() == 5) {
                        return date < tomorrowPlusThree || date > new Date(tomorrowPlusThree.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                    } else {
                        //return date < tomorrowPlusOne || date > new Date(tomorrowPlusOne.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6;
                        return date < tomorrowPlusTwo || date > new Date(tomorrowPlusTwo.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                    }
                } else {
                    if (now.isoWeekday() == 5) {
                        return date < tomorrowPlusTwo || date > new Date(tomorrowPlusTwo.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                    } else {
                        //return date < tomorrow || date > new Date(tomorrow.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6;
                        return date < tomorrowPlusOne || date > new Date(tomorrowPlusOne.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                    }
                }
            },

            disableDatesBeforeTodayPeriod(date) {
                const day = new Date(date).getDay()

                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const tomorrow = new Date(today);
                tomorrow.setDate(tomorrow.getDate() + 1);

                const tomorrowPlusOne = new Date(today);
                tomorrowPlusOne.setDate(tomorrowPlusOne.getDate() + 7);

                const tomorrowPlusTwo = new Date(today);
                tomorrowPlusTwo.setDate(tomorrowPlusTwo.getDate() + 8);

                const tomorrowPlusThree = new Date(today);
                tomorrowPlusThree.setDate(tomorrowPlusThree.getDate() + 9);

                var now = moment();

                if (now.hour() >= 10) {
                    if (now.isoWeekday() == 5) {
                        return date < tomorrowPlusThree || date > new Date(tomorrowPlusThree.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                    } else {
                        //return date < tomorrowPlusOne || date > new Date(tomorrowPlusOne.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6;
                        return date < tomorrowPlusTwo || date > new Date(tomorrowPlusTwo.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                    }
                } else {
                    if (now.isoWeekday() == 5) {
                        return date < tomorrowPlusTwo || date > new Date(tomorrowPlusTwo.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                    } else {
                        //return date < tomorrow || date > new Date(tomorrow.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6;
                        return date < tomorrowPlusOne || date > new Date(tomorrowPlusOne.getTime() + 60 * 24 * 3600 * 1000) || day === 0 || day === 6 || this.getPublicHolidays(moment(new Date(date)).format('YYYY')).includes(moment(new Date(date)).format('MM-DD'));
                    }
                }
            },

            populateForm() {
                this.serviceName = this.service.name;
                this.serviceWorkroomId = this.service.workroom_id;
                this.license = this.licensePlate;

                this.firstName = this.clientPersonalData ? this.clientPersonalData.first_name : '';
                this.lastName = this.clientPersonalData ? this.clientPersonalData.last_name : '';
                this.emailAddress = this.clientPersonalData ? this.clientPersonalData.email : '';
                this.phoneNumber = this.clientPersonalData ? this.clientPersonalData.phone : '';
            },

            submitOrderService() {
                if (this.extendedServicesOperations.includes('pick-up') && this.pickupStreet && this.pickupTown && this.pickupZip) {
                    this.doGeocode(this.pickupStreet + ', ' + this.pickupTown + ', ' + this.pickupZip)
                        .then((response) => {
                            this.validations.pickupGeocode.is_valid = true;
                            this.validations.pickupGeocode.text = '';

                            var geolocated_address = this.getAddressObject(response.address_components);

                            if (geolocated_address.city != 'Temelín' && (geolocated_address.street == '' || geolocated_address.city == '' || geolocated_address.postal_code == '')) {
                                this.validations.pickupStreet.is_valid = true;
                                this.validations.pickupStreet.text = '';

                                this.validations.pickupTown.is_valid = true;
                                this.validations.pickupTown.text = '';

                                this.validations.pickupZip.is_valid = true;
                                this.validations.pickupZip.text = '';

                                this.validations.pickupGeocode.is_valid = false;
                                this.validations.pickupGeocode.text = this.$t('order.supplementaryServicesPickUpAddressNotFound');
                            } else {
                                if (this.validateOrderService()) {
                                    this.$store.dispatch('orderToService', {
                                        serviceWorkroomId: this.serviceWorkroomId,
                                        serviceName: this.serviceName,
                                        selectedSlot: this.$selectedSlot,
                                        selectedEvent: this.selectedEvent,
                                        slotTime: this.slotTime,
                                        preferredLanguage: this.$i18n.locale,
                                        clientLocation: this.clientLocation,
                                        licensePlate: this.licensePlate,
                                        mileage: this.mileage,
                                        firstName: this.firstName,
                                        lastName: this.lastName,
                                        emailAddress: this.emailAddress,
                                        phoneNumber: this.phoneNumber,
                                        phoneNumberPrefix: this.phoneNumberResults.countryCallingCode,
                                        checkedDateType: this.checkedDateType,
                                        preferredDate1: this.preferredDate1,
                                        preferredDateTime1: this.preferredDateTime1,
                                        preferredDate2: this.preferredDate2,
                                        preferredDateTime2: this.preferredDateTime2,
                                        preferredDate3: this.preferredDate3,
                                        preferredDateTime3: this.preferredDateTime3,
                                        preferredDatePeriod: this.preferredDatePeriod,
                                        preferredDatePeriodFrom: this.preferredDatePeriodFrom,
                                        serviceOperations: this.serviceOperations,
                                        serviceOperationsRepairText: this.serviceOperationsRepairText,
                                        serviceOperationsBreakdownText: this.serviceOperationsBreakdownText,
                                        serviceOperationsOtherText: this.serviceOperationsOtherText,
                                        extendedServicesOperations: this.extendedServicesOperations,
                                        extendedServicesOperationsReplacementCarAdditional: this.extendedServicesOperationsReplacementCarAdditional,
                                        serviceSupplierLocation: this.serviceSupplierLocation,
                                        pickupNote: this.pickupNote,
                                        pickupStreet: geolocated_address.street + ' ' + ((geolocated_address.home && geolocated_address.number) ? geolocated_address.home + '/' + geolocated_address.number : (geolocated_address.home || geolocated_address.number)),
                                        pickupTown: geolocated_address.city,
                                        pickupZip: geolocated_address.postal_code,
                                        pickupGpsLat: response.geometry.location.lat(),
                                        pickupGpsLng: response.geometry.location.lng(),
                                        service: this.service,
                                        serviceSlotDefinition: this.serviceSlotDefinition
                                    });
                                }
                            }
                        })
                        .catch((error) => {
                            this.validations.pickupStreet.is_valid = true;
                            this.validations.pickupStreet.text = '';

                            this.validations.pickupTown.is_valid = true;
                            this.validations.pickupTown.text = '';

                            this.validations.pickupZip.is_valid = true;
                            this.validations.pickupZip.text = '';

                            this.validations.pickupGeocode.is_valid = false;
                            this.validations.pickupGeocode.text = this.$t('order.supplementaryServicesPickUpAddressNotFound');
                        });
                } else {
                    if (this.validateOrderService()) {
                        this.$store.dispatch('orderToService', {
                            serviceWorkroomId: this.serviceWorkroomId,
                            serviceName: this.serviceName,
                            selectedSlot: this.$selectedSlot,
                            selectedEvent: this.selectedEvent,
                            slotTime: this.slotTime,
                            clientLocation: this.clientLocation,
                            preferredLanguage: this.$i18n.locale,
                            licensePlate: this.licensePlate,
                            mileage: this.mileage,
                            firstName: this.firstName,
                            lastName: this.lastName,
                            emailAddress: this.emailAddress,
                            phoneNumber: this.phoneNumber,
                            phoneNumberPrefix: this.phoneNumberResults.countryCallingCode,
                            checkedDateType: this.checkedDateType,
                            preferredDate1: this.preferredDate1,
                            preferredDateTime1: this.preferredDateTime1,
                            preferredDate2: this.preferredDate2,
                            preferredDateTime2: this.preferredDateTime2,
                            preferredDate3: this.preferredDate3,
                            preferredDateTime3: this.preferredDateTime3,
                            preferredDatePeriod: this.preferredDatePeriod,
                            preferredDatePeriodFrom: this.preferredDatePeriodFrom,
                            serviceOperations: this.serviceOperations,
                            serviceOperationsRepairText: this.serviceOperationsRepairText,
                            serviceOperationsBreakdownText: this.serviceOperationsBreakdownText,
                            serviceOperationsOtherText: this.serviceOperationsOtherText,
                            extendedServicesOperations: this.extendedServicesOperations,
                            extendedServicesOperationsReplacementCarAdditional: this.extendedServicesOperationsReplacementCarAdditional,
                            serviceSupplierLocation: this.serviceSupplierLocation,
                            pickupNote: this.pickupNote,
                            pickupStreet: this.pickupStreet,
                            pickupTown: this.pickupTown,
                            pickupZip: this.pickupZip,
                            pickupGpsLat: null,
                            pickupGpsLng: null,
                            service: this.service,
                            serviceSlotDefinition: this.serviceSlotDefinition
                        });
                    }
                }
            },

            validateOrderService() {
                let validOrderServiceForm = true;

                if (this.mileage.trim() == '') {
                    validOrderServiceForm = false;
                    this.validations.mileage.is_valid = false;
                    this.validations.mileage.text = this.$t('order.mileageValidation');
                    this.$refs['mileage'].focus();
                } else {
                    this.validations.mileage.is_valid = true;
                    this.validations.mileage.text = '';
                }

                if (this.firstName.trim() == '') {
                    validOrderServiceForm = false;
                    this.validations.firstName.is_valid = false;
                    this.validations.firstName.text = this.$t('order.firstNameValidation');
                    this.$refs['firstName'].focus();
                } else {
                    this.validations.firstName.is_valid = true;
                    this.validations.firstName.text = '';
                }

                if (this.lastName.trim() == '') {
                    validOrderServiceForm = false;
                    this.validations.lastName.is_valid = false;
                    this.validations.lastName.text = this.$t('order.lastNameValidation');
                    this.$refs['lastName'].focus();
                } else {
                    this.validations.lastName.is_valid = true;
                    this.validations.lastName.text = '';
                }

                if (this.emailAddress.trim() == '') {
                    validOrderServiceForm = false;
                    this.validations.emailAddress.is_valid = false;
                    this.validations.emailAddress.text = this.$t('order.emailValidation');
                    this.$refs['emailAddress'].focus();
                } else {
                    if (!this.validEmail(this.emailAddress.trim())) {
                        validOrderServiceForm = false;
                        this.validations.emailAddress.is_valid = false;
                        this.validations.emailAddress.text = this.$t('order.emailValidationFormat');
                        this.$refs['emailAddress'].focus();
                    } else {
                        this.validations.emailAddress.is_valid = true;
                        this.validations.emailAddress.text = '';
                    }
                }

                if (this.phoneNumber == '' || this.phoneNumber == null) {
                    validOrderServiceForm = false;
                    this.validations.phoneNumber.is_valid = false;
                    this.validations.phoneNumber.text = this.$t('order.phoneValidation');
                } else {
                    if (this.phoneNumber.replace(/\s/g, '').length < 9 || this.phoneNumberResults.isValid == false) {
                        validOrderServiceForm = false;
                        this.validations.phoneNumber.is_valid = false;
                        this.validations.phoneNumber.text = this.$t('order.phoneValidationFormat');
                        this.$refs['emailAddress'].focus();
                    } else {
                        this.validations.phoneNumber.is_valid = true;
                        this.validations.phoneNumber.text = '';
                    }
                }

                if (this.service.maintenance_slot && !this.makeId) {
                    if (this.$selectedSlot == null) {
                        validOrderServiceForm = false;
                        this.validations.selectedSlot.is_valid = false;
                        this.validations.selectedSlot.text = this.$t('order.selectionDateSectionValidation');
                    } else {
                        this.validations.selectedSlot.is_valid = true;
                        this.validations.selectedSlot.text = '';
                    }

                    if (this.slotTime == '' || this.slotTime == null) {
                        validOrderServiceForm = false;
                        this.validations.slotTime.is_valid = false;
                        this.validations.slotTime.text = this.$t('order.selectionDateSectionTimeValidation');
                    } else {
                        this.validations.slotTime.is_valid = true;
                        this.validations.slotTime.text = '';
                    }
                } else {
                    if (this.checkedDateType == 'preferred_dates') {
                        if (this.preferredDate1 == '' || this.preferredDate1 == null || this.preferredDateTime1 == '' || this.preferredDateTime1 == null) {
                            validOrderServiceForm = false;
                            this.validations.preferredDate1.is_valid = false;
                            this.validations.preferredDate1.text = this.$t('order.termSectionPreferredDatesValidation');
                        } else {
                            this.validations.preferredDate1.is_valid = true;
                            this.validations.preferredDate1.text = '';
                        }

                        if (this.preferredDate2 == '' || this.preferredDate2 == null || this.preferredDateTime2 == '' || this.preferredDateTime2 == null) {
                            validOrderServiceForm = false;
                            this.validations.preferredDate2.is_valid = false;
                            this.validations.preferredDate2.text = this.$t('order.termSectionPreferredDatesValidation');
                        } else {
                            this.validations.preferredDate2.is_valid = true;
                            this.validations.preferredDate2.text = '';
                        }

                        if (this.preferredDate3 == '' || this.preferredDate3 == null || this.preferredDateTime3 == '' || this.preferredDateTime3 == null) {
                            validOrderServiceForm = false;
                            this.validations.preferredDate3.is_valid = false;
                            this.validations.preferredDate3.text = this.$t('order.termSectionPreferredDatesValidation');
                        } else {
                            this.validations.preferredDate3.is_valid = true;
                            this.validations.preferredDate3.text = '';
                        }
                    } else {
                        if (this.preferredDatePeriod == '' || this.preferredDatePeriod == null) {
                            validOrderServiceForm = false;
                            this.validations.preferredDatePeriod.is_valid = false;
                            this.validations.preferredDatePeriod.text = this.$t('order.termSectionPeriodValidation');
                        } else {
                            if (this.preferredDatePeriod[0] == this.preferredDatePeriod[1]) {
                                validOrderServiceForm = false;
                                this.validations.preferredDatePeriod.is_valid = false;
                                this.validations.preferredDatePeriod.text = this.$t('order.termSectionPeriodValidation');
                            } else {
                                this.validations.preferredDatePeriod.is_valid = true;
                                this.validations.preferredDatePeriod.text = '';
                            }
                        }

                        if (this.preferredDatePeriodFrom == '' || this.preferredDatePeriodFrom == null) {
                            validOrderServiceForm = false;
                            this.validations.preferredDatePeriodFrom.is_valid = false;
                            this.validations.preferredDatePeriodFrom.text = this.$t('order.termSectionTimeValidation');
                        } else {
                            this.validations.preferredDatePeriodFrom.is_valid = true;
                            this.validations.preferredDatePeriodFrom.text = '';
                        }
                    }

                    if (this.serviceSupplierLocation.trim() == '') {
                        validOrderServiceForm = false;
                        this.validations.serviceSupplierLocation.is_valid = false;
                        this.validations.serviceSupplierLocation.text = this.$t('order.serviceSupplierLocationValidation');
                    } else {
                        this.validations.serviceSupplierLocation.is_valid = true;
                        this.validations.serviceSupplierLocation.text = '';
                    }
                }

                if (this.serviceOperations.length == 0) {
                    validOrderServiceForm = false;
                    this.validations.serviceOperations.is_valid = false;
                    this.validations.serviceOperations.text = this.$t('order.servicingActionSectionValidation');
                } else {
                    this.validations.serviceOperations.is_valid = true;
                    this.validations.serviceOperations.text = '';
                }

                if (this.serviceOperations.includes('repair')) {
                    if (this.serviceOperationsRepairText.trim() == '') {
                        validOrderServiceForm = false;
                        this.validations.serviceOperationsRepairText.is_valid = false;
                        this.validations.serviceOperationsRepairText.text = this.$t('order.servicingActionInputTextValidation');
                    } else {
                        this.validations.serviceOperationsRepairText.is_valid = true;
                        this.validations.serviceOperationsRepairText.text = '';
                    }
                }

                if (this.serviceOperations.includes('technical-inspection')) {
                    if (!this.serviceOperationsTechnicalInspectionAdditional) {
                        validOrderServiceForm = false;
                        this.validations.serviceOperationsTechnicalInspectionAdditional.is_valid = false;
                        this.validations.serviceOperationsTechnicalInspectionAdditional.text = this.$t('order.servicingActionInputCheckboxValidation');
                    } else {
                        this.validations.serviceOperationsTechnicalInspectionAdditional.is_valid = true;
                        this.validations.serviceOperationsTechnicalInspectionAdditional.text = '';
                    }
                }

                if (this.serviceOperations.includes('breakdown')) {
                    if (this.serviceOperationsBreakdownText.trim() == '') {
                        validOrderServiceForm = false;
                        this.validations.serviceOperationsBreakdownText.is_valid = false;
                        this.validations.serviceOperationsBreakdownText.text = this.$t('order.servicingActionInputTextValidation');
                    } else {
                        this.validations.serviceOperationsBreakdownText.is_valid = true;
                        this.validations.serviceOperationsBreakdownText.text = '';
                    }
                }

                if (this.serviceOperations.includes('other')) {
                    if (this.serviceOperationsOtherText.trim() == '') {
                        validOrderServiceForm = false;
                        this.validations.serviceOperationsOtherText.is_valid = false;
                        this.validations.serviceOperationsOtherText.text = this.$t('order.servicingActionInputTextValidation');
                    } else {
                        this.validations.serviceOperationsOtherText.is_valid = true;
                        this.validations.serviceOperationsOtherText.text = '';
                    }
                }

                if (this.extendedServicesOperations.includes('pick-up')) {
                    if (this.pickupStreet.trim() == '') {
                        validOrderServiceForm = false;
                        this.validations.pickupStreet.is_valid = false;
                        this.validations.pickupStreet.text = this.$t('order.supplementaryServicesPickUpStreetValidation');
                    } else {
                        if (!this.validStreet(this.pickupStreet.trim())) {
                            this.validations.pickupStreet.is_valid = false;
                            this.validations.pickupStreet.text = this.$t('order.supplementaryServicesPickUpStreetValidation');
                        } else {
                            this.validations.pickupStreet.is_valid = true;
                            this.validations.pickupStreet.text = '';
                        }
                    }

                    if (this.pickupTown.trim() == '') {
                        validOrderServiceForm = false;
                        this.validations.pickupTown.is_valid = false;
                        this.validations.pickupTown.text = this.$t('order.supplementaryServicesPickUpTownValidation');
                    } else {
                        this.validations.pickupTown.is_valid = true;
                        this.validations.pickupTown.text = '';
                    }

                    if (this.pickupZip.trim() == '') {
                        validOrderServiceForm = false;
                        this.validations.pickupZip.is_valid = false;
                        this.validations.pickupZip.text = this.$t('order.supplementaryServicesPickUpZipValidation');
                    } else {
                        this.validations.pickupZip.is_valid = true;
                        this.validations.pickupZip.text = '';
                    }
                }

                if (!validOrderServiceForm) {
                    this.$store.dispatch('flashMessageShow', { type: 'info', message: this.$t('order.warningFormSubmit') }, { root: true })
                }

                return validOrderServiceForm;
            },

            validNumber(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;

                if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },

            validEmail(email) {
                //var regExprEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                var regExprEmail = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

                return regExprEmail.test(email);
            },

            validStreet(street) {
                var regExprStreet = /\d/g;

                return regExprStreet.test(street);
            },

            clearForm() {
                this.serviceName = '';
                this.serviceID = '';
                this.mileage = '';
                this.firstName = '';
                this.lastName = '';
                this.emailAddress = '';
                this.phoneNumber = '';
                this.preferredDate1 = '';
                this.preferredDate2 = '';
                this.preferredDate3 = '';
                this.preferredDatePeriod = '';

                this.validations = {
                    mileage: {
                        is_valid: true,
                        text: ''
                    },
                    firstName: {
                        is_valid: true,
                        text: ''
                    },
                    lastName: {
                        is_valid: true,
                        text: ''
                    },
                    emailAddress: {
                        is_valid: true,
                        text: ''
                    },
                    phoneNumber: {
                        is_valid: true,
                        text: ''
                    },
                    selectedSlot: {
                        is_valid: true,
                        text: ''
                    },
                    slotTime: {
                        is_valid: true,
                        text: ''
                    },
                    preferredDate1: {
                        is_valid: true,
                        text: ''
                    },
                    preferredDate2: {
                        is_valid: true,
                        text: ''
                    },
                    preferredDate3: {
                        is_valid: true,
                        text: ''
                    },
                    preferredDatePeriod: {
                        is_valid: true,
                        text: ''
                    },
                    preferredDatePeriodFrom: {
                        is_valid: true,
                        text: ''
                    },
                    pickupStreet: {
                        is_valid: true,
                        text: ''
                    },
                    pickupTown: {
                        is_valid: true,
                        text: ''
                    },
                    pickupZip: {
                        is_valid: true,
                        text: ''
                    },
                    pickupGeocode: {
                        is_valid: true,
                        text: ''
                    }
                };
            },

            formatDate(value) {
                if (value) {
                    return moment(new Date(value)).format('DD. MM. YYYY')
                }
            },

            closeModal() {
                if (this.$selectedSlot) {
                    var refsItem = this.$refs['slot-' + this.$selectedSlotId];

                    if (refsItem) {
                        refsItem.classList.remove('selected_event');
                    }

                    this.$store.dispatch('unblockServiceSlot', {
                        slot_id: this.$selectedSlot
                    });
                }

                this.$router.push({ name: 'services' });
            },

            onEventClick(event, e) {
                this.selectedEvent = event;

                if (this.$selectedSlot) {
                    var refsItem = this.$refs['slot-' + this.$selectedSlot];

                    if (refsItem) {
                        refsItem.classList.remove('selected_event');
                    }

                    this.$store.dispatch('unblockServiceSlot', {
                        slot_id: this.$selectedSlot
                    });

                    this.slotReservationCountdown = moment(180 * 10 * 1000);
                }

                this.$selectedSlot = event.id;

                this.$refs['slot-' + event.id].classList.add('selected_event');

                this.$store.dispatch('blockServiceSlot', {
                    slot_id: this.$selectedSlot
                });

                this.slotReservationCountdown = moment(180 * 10 * 1000);

                if (!this.enabledSlotReservationCounter) {
                    setInterval(() => {
                        this.slotReservationCountdown = moment(this.slotReservationCountdown.subtract(1, 'seconds'))
                    }, 1000);

                    this.enabledSlotReservationCounter = true;
                }

                e.stopPropagation();
            },

            onEventFocus(event, e) {
                this.selectedEvent = event;

                /*
                var vueCallCells = document.querySelectorAll(".vuecal__cell");
                var myArray = Array.from(vueCallCells);

                function getKeyByValue(object, value) {
                  return Object.keys(object).find(key => object[key] === value);
                }

                setTimeout(() => {
                  var vueCallCellsSelected = document.querySelector(".vuecal__cell--selected");

                  console.log(vueCallCellsSelected)
                  console.log(getKeyByValue(myArray, vueCallCellsSelected));
                }, 300);
                */

                if (this.$selectedSlot) {
                    var refsItem = this.$refs['slot-' + this.$selectedSlotId];

                    if (refsItem) {
                        refsItem.classList.remove('selected_event');
                    }

                    this.$store.dispatch('unblockServiceSlot', {
                        slot_id: this.$selectedSlot
                    });

                    this.slotReservationCountdown = moment(180 * 10 * 1000);
                }

                this.$selectedSlotId = event.id;
                this.$selectedSlot = event.id_origin;
                this.$selectedSlotDate = event.slot_date;

                this.$refs['slot-' + event.id].classList.add('selected_event');

                setTimeout(() => {
                    this.$store.dispatch('blockServiceSlot', {
                        slot_id: this.$selectedSlot,
                        blocked_date: this.$selectedSlotDate
                    });
                }, 500);

                this.slotReservationCountdown = moment(180 * 10 * 1000);

                if (!this.enabledSlotReservationCounter) {
                    setInterval(() => {
                        this.slotReservationCountdown = moment(this.slotReservationCountdown.subtract(1, 'seconds'))
                    }, 1000);

                    this.enabledSlotReservationCounter = true;
                }
            },

            customEventCreation(value) {
                this.$refs.vuecal.createEvent(
                    value.start,
                    120, // event duration
                    {
                        title: value.title,
                        content: value.content,
                        class: 'blue-event'
                    }
                );
            },

            clickedPrevCal() {
                if (this.$selectedSlotId) {
                    setTimeout(() => {
                        var slotElementsPrev = document.querySelectorAll('*[id^="slot-"]');

                        for (var i = 0; i < slotElementsPrev.length; i++) {
                            slotElementsPrev[i].classList.remove('selected_event');

                            if (slotElementsPrev[i].id.includes(this.$selectedSlotId)) {
                                slotElementsPrev[i].classList.add('selected_event');
                            }
                        }
                    }, 300);
                }
            },

            clickedNextCal() {
                if (this.$selectedSlotId) {
                    setTimeout(() => {
                        var slotElementsNext = document.querySelectorAll('*[id^="slot-"]');

                        for (var i = 0; i < slotElementsNext.length; i++) {
                            slotElementsNext[i].classList.remove('selected_event');

                            if (slotElementsNext[i].id.includes(this.$selectedSlotId)) {
                                slotElementsNext[i].classList.add('selected_event');
                            }
                        }
                    }, 300);
                }
            },

            onUpdatePhoneNumber(payload) {
                this.phoneNumberResults = payload;
            },

            doGeocode(address) {
                const geocoder = new google.maps.Geocoder();

                return new Promise((resolve, reject) => {
                    geocoder.geocode(
                        {
                            address: address
                        },
                        (results, status) => {
                            if (status === google.maps.GeocoderStatus.OK) {
                                resolve(results[0]);
                            } else {
                                reject(new Error(status));
                            }
                        }
                    );
                });
            },

            getAddressObject(address_components) {
                var ShouldBeComponent = {
                    number: ["street_number"],
                    home: ["premise"],
                    postal_code: ["postal_code"],
                    street: ["street_address", "route", "neighborhood", "locality"],
                    region: [
                        "administrative_area_level_1",
                        "administrative_area_level_2",
                        "administrative_area_level_3",
                        "administrative_area_level_4",
                        "administrative_area_level_5"
                    ],
                    city: [
                        "postal_town",
                        "locality",
                        "sublocality",
                        "political",
                        "administrative_area_level_2",
                        "sublocality_level_1",
                        "sublocality_level_2",
                        "sublocality_level_3",
                        "sublocality_level_4"
                    ],
                    country: ["country"]
                };

                var address = {
                    number: "",
                    home: "",
                    postal_code: "",
                    street: "",
                    region: "",
                    city: "",
                    country: ""
                };

                address_components.forEach(component => {
                    for (var shouldBe in ShouldBeComponent) {
                        if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
                            if (address[shouldBe] === "") {
                                address[shouldBe] = component.long_name;
                            }
                        }
                    }
                });

                return address;
            },

            preferredDatePeriodPick(date) {
                var previousDate = new Date(date).setDate(date.getDate() - 1);
                var previousSecondDate = new Date(date).setDate(date.getDate() - 2);
                var nextDate = new Date(date).setDate(date.getDate() + 1);
                var nextSecondDate = new Date(date).setDate(date.getDate() + 2);

                var pickedDateString = moment(new Date(date)).format('YYYY-MM-DD');
                var previousDateString = moment(previousDate).format('YYYY-MM-DD');
                var previousSecondDateString = moment(previousSecondDate).format('YYYY-MM-DD');
                var nextDateString = moment(nextDate).format('YYYY-MM-DD');
                var nextSecondDateString = moment(nextSecondDate).format('YYYY-MM-DD');

                //console.log('Picked date: ' + pickedDateString);
                //console.log('Previous date: ' + previousDateString);
                //console.log('Next date: ' + nextDateString);

                var previousCells = document.querySelectorAll("td.cell[title='" + previousDateString + "']");
                //console.log(previousCells);

                for (var x = 0, len = previousCells.length; x < len; x++) {
                    this.disableCellClick(previousCells[x]);
                    previousCells[x].removeAttribute('data-day');
                    //previousCells[x].classList.add('disabled');
                    previousCells[x].setAttribute('style', 'background-color: #f3f3f3 !important;color: #ccc !important;cursor: not-allowed !important;');
                }

                var previousSecondCells = document.querySelectorAll("td.cell[title='" + previousSecondDateString + "']");

                for (var x = 0, len = previousSecondCells.length; x < len; x++) {
                    this.disableCellClick(previousSecondCells[x]);
                    previousSecondCells[x].removeAttribute('data-day');
                    previousSecondCells[x].setAttribute('style', 'background-color: #f3f3f3 !important;color: #ccc !important;cursor: not-allowed !important;');
                }


                var nextCells = document.querySelectorAll("td.cell[title='" + nextDateString + "']");

                for (var i = 0, len = nextCells.length; i < len; i++) {
                    this.disableCellClick(nextCells[i]);
                    nextCells[i].removeAttribute('data-day');
                    nextCells[i].setAttribute('style', 'background-color: #f3f3f3 !important;color: #ccc !important;cursor: not-allowed !important;');
                }

                var nextSecondCells = document.querySelectorAll("td.cell[title='" + nextSecondDateString + "']");

                for (var i = 0, len = nextSecondCells.length; i < len; i++) {
                    this.disableCellClick(nextSecondCells[i]);
                    nextSecondCells[i].removeAttribute('data-day');
                    nextSecondCells[i].setAttribute('style', 'background-color: #f3f3f3 !important;color: #ccc !important;cursor: not-allowed !important;');
                }

                // client selected friday
                var pickedDateWeekday = moment(new Date(date)).isoWeekday();

                if (pickedDateWeekday == 5) {
                    var nextDateMonday = new Date(date).setDate(date.getDate() + 3);
                    var nextDateMondayString = moment(nextDateMonday).format('YYYY-MM-DD');

                    var nextMondayCells = document.querySelectorAll("td.cell[title='" + nextDateMondayString + "']");

                    for (var i = 0, len = nextMondayCells.length; i < len; i++) {
                        this.disableCellClick(nextMondayCells[i]);
                        nextMondayCells[i].removeAttribute('data-day');
                        nextMondayCells[i].setAttribute('style', 'background-color: #f3f3f3 !important;color: #ccc !important;cursor: not-allowed !important;');
                    }
                }

                // client selected monday
                if (pickedDateWeekday == 1) {
                    var previousDateFriday = new Date(date).setDate(date.getDate() - 3);
                    var previousDateFridayString = moment(previousDateFriday).format('YYYY-MM-DD');

                    var previousFridayCells = document.querySelectorAll("td.cell[title='" + previousDateFridayString + "']");

                    for (var i = 0, len = previousFridayCells.length; i < len; i++) {
                        this.disableCellClick(previousFridayCells[i]);
                        previousFridayCells[i].removeAttribute('data-day');
                        previousFridayCells[i].setAttribute('style', 'background-color: #f3f3f3 !important;color: #ccc !important;cursor: not-allowed !important;');
                    }
                }
            },

            getPublicHolidays(year) {
                return [
                    '01-01',
                    this.getGoodFriday(year).format('MM-DD'),
                    this.getEasterMonday(year).format('MM-DD'),
                    '05-01',
                    '05-08',
                    '07-05',
                    '07-06',
                    '09-28',
                    '10-28',
                    '11-17',
                    '12-24',
                    '12-25',
                    '12-26'
                ];
            },

            getEasterMonday(year) {
                var a = (year / 100 | 0) * 1483 - (year / 400 | 0) * 2225 + 2613;
                var b = ((year % 19 * 3510 + (a / 25 | 0) * 319) / 330 | 0) % 29;
                var c = 148 - b - ((year * 5 / 4 | 0) + a - b) % 7;

                return moment({year: year, month: (c / 31 | 0) - 1, day: c % 31 + 1}).add(1, 'days');
            },

            getGoodFriday(year) {
                var a = (year / 100 | 0) * 1483 - (year / 400 | 0) * 2225 + 2613;
                var b = ((year % 19 * 3510 + (a / 25 | 0) * 319) / 330 | 0) % 29;
                var c = 148 - b - ((year * 5 / 4 | 0) + a - b) % 7;

                return moment({year: year, month: (c / 31 | 0) - 1, day: c % 31 + 1}).subtract(2, 'days');
            },

            disableCellClick(cell) {
                cell.addEventListener('click', function(event) {
                    event.stopPropagation();
                });
            }
        }
    }
</script>

<style lang="scss">
    .vuecal__title {
        font-family: 'Raleway', sans-serif;
        font-size: 16px;
        font-weight: bold;
    }

    .vuecal__cell-events {
        padding: 5px;
    }

    .vuecal__event {
        background: #28a745;
        color: white;
        cursor: pointer;
        font-family: 'Raleway', sans-serif;
        font-weight: bold;
        font-size: 14px;

        border-radius: 5px;
        border: 1px solid #dce0e7;

        margin-top: 5px;
        /*padding-top: 10px;*/
        /*padding-bottom: 10px;*/
    }

    .vuecal__event-title {
        width: 100%;
        height: 100%;
        padding: 10px;
    }

    .vuecal__event--focus {
        color: white;
        //background: #c8017d;
    }

    .vuecal__no-event {
        display: none;
    }

    .vuecal__flex {
        font-family: 'Raleway', sans-serif;
        font-size: 14px;
        font-weight: bold;
    }

    .vuecal__title-bar {
        background-color: #e2e2e2;
    }

    .vuecal__cell--today, .vuecal__cell--current {
        background-color: transparent;
        border: 1px solid black;
    }

    .vuecal:not(.vuecal--day-view) .vuecal__cell--selected {
        background-color: transparent;
    }


    .vuecal__cell--highlighted:not(.vuecal__cell--has-splits),
    .vuecal__cell-split--highlighted {
        background-color: rgba(195, 255, 225, 0.5);
    }

    .vuecal__arrow.vuecal__arrow--highlighted,
    .vuecal__view-btn.vuecal__view-btn--highlighted {
        background-color: rgba(136, 236, 191, 0.25);
    }

    .selected_event {
        background: #c8017d;
    }

    /* Small only */
    @media screen and (max-width: 39.9375em) {
        .vuecal__event-title {
            color: transparent;
        }
    }


    $primary-color: #c8017d;
    $popup-z-index: 10000 !default;

    @import '~vue2-datepicker/scss/index.scss';

    .mx-datepicker {
        display: block;
        margin: 0 auto;
        width: 170px;
    }

    .preferred-date-period {
        .mx-datepicker {
            display: block;
            margin: 0 auto;
            width: 240px;
        }
    }

    .mx-input {
        text-align: center;
    }

    .mx-input-wrapper {
        input[readonly] {
            background-color: #fff !important;
        }
    }

    .mx-icon-calendar, .mx-icon-clear {
        top: 35%
    }

    .mx-table-date .cell.not-current-month {
        color: #73879c !important;
    }

    .mx-calendar-content .cell.disabled {
        color: #ccc !important;
    }

    .mx-calendar-content .cell.in-range {
        color: #73879c !important;
        background-color: #fce4dc !important;
    }

    .mx-calendar-content .cell.active {
        color: #fff !important;
        background-color: #c8017d !important;
    }

    .mx-table-date thead tr th {
        text-align: center;
    }

    .mx-table-date tbody tr:nth-child(even) {
        background-color: transparent !important;
    }



    div.vue-phone-number-input {
        margin: 0 0 1rem;
    }

    div.select-country-container {
        z-index: 2;

        label {
            font-size: 11px !important;
        }

        .align-center {
            -webkit-box-align: center !important;
            -ms-flex-align: center !important;
            align-items: center !important;
            justify-content: left !important;
        }
    }

    div.input-tel {
        .input-tel__label {
            font-size: 11px !important;
        }
    }

    div.v-select {
        margin: 0 auto;
        width: 170px;
    }

    input.vs__search {
        height: 1.5rem;
        background: none;
    }
    span.vs__selected {
        color: #555;
        font-size: 14px;
        margin: 4px 2px 0px 20px;
    }
    .vs__dropdown-option {
        color: #73879c;
        font-size: 14px;
    }
    .vs__dropdown-option--highlight {
        background: #c8017d;
        color: #fff;
    }
    .country-selector__list {
        height: 60px !important;
    }
    .phone-number-section-note {
        color: #c8017d !important;
        font-weight: bold;
    }
</style>
